// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes fade-scrim{0%{opacity:0}to{opacity:var(--scrim-opacity)}}.scrim{--scrim-opacity:0.85;background-color:#0f0f92;opacity:.85;opacity:var(--scrim-opacity)}.fade-scrim-enter-active{animation:fade-scrim var(--fade-speed) forwards;pointer-events:none}.fade-scrim-leave-active{animation:fade-scrim var(--fade-speed) reverse forwards}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
